import { Schema as S } from "effect";

/**
 * Check Quarterly Coverage Request Schema
 *
 * Request to check if a patient has valid GKV coverage for the current quarter.
 */
export const CheckQuarterlyCoverageRequestSchema = S.Struct({
  /** Patient ID to check coverage for */
  patientId: S.String,
});

export type CheckQuarterlyCoverageRequest = S.Schema.Type<
  typeof CheckQuarterlyCoverageRequestSchema
>;
